import ElgigantenLogo from "branchAndBrandSpecific/utils/brandVariables/assets/elgiganten/gigantti.svg";
import Image from "../assets/elgiganten_giveaway_glitched.webp";

export const ElgigantenHomeCarouselData = [
  {
    coverURL: Image,
    logoURL: ElgigantenLogo,
    alt: "Elgiganten Logo",
    heading: "Main Stage Gaming Giveaway",
    desc: "Expect loads of awesome Gigantti Gaming merch, exclusive items from our partners, and Gaming products worth thousands of euros. Don’t miss this spectacle – Gigantti Gaming and its partners are bringing their A-game!",
    links: [
      {
        text: "Check the schedule",
        url: "https://assembly.org/en/events/summer25/schedule",
      },
    ],
    theme: "elgiganten",
  },
  {
    coverURL: Image,
    logoURL: ElgigantenLogo,
    alt: "Elgiganten Logo",
    heading: "CS2 Wingman - tournament",
    desc: "On Friday from 19:00 to 21:00, Gigantti hosts an 8-team CS2 Wingman tournament at the Red Bull Gaming Sphere. The winning duo will receive amazing product prizes from AOC! Registration is open on the event day at the Sphere.",
    links: [
      {
        text: "Check the schedule",
        url: "https://assembly.org/en/events/summer25/schedule",
      },
    ],
    theme: "elgiganten",
  },
];
